import React, { useContext } from "react";
import type { BillLine, Price } from "../../app-patient/_objects-patient";
import { EditContext, type IOProps } from "../../widget/io-abstract";
import IOBoolean from "../../widget/io-boolean";
import IONumber from "../../widget/io-number";
import "./io-bill-line.css";

export default function IOBillLine(
  props: {
    index: number;
    value: BillLine;
    price: Price;
  } & IOProps<BillLine>
): React.ReactNode {
  const edit = useContext(EditContext);

  const onChange = (value: number = props.value.value) => {
    if (props.onChange) {
      props.onChange({
        ...(props.value as BillLine),
        value: value
      });
    }
  };

  // Hide if not value and output mode
  if (!edit && !props.value.value) {
    return;
  }

  const prefix = (
    <>
      {props.value.id && (
        <input
          type="hidden"
          name={`bill_lines.${props.index}.id`}
          value={props.value.id}
        />
      )}
      <input
        type="hidden"
        name={`bill_lines.${props.index}.price_id`}
        value={props.price.id}
      />
    </>
  );

  const commonProps = {
    type: "bill-line",
    name: `bill_lines.${props.index}.value`,
    label: props.price?.key ?? "",
    value: props.value.value,
    required: true,
    onChange: onChange
  };

  if (props.price?.price > 1) {
    return (
      <>
        {prefix}
        <IOBoolean
          {...commonProps}
          appendix={`${props.price.price}৳`}
          value={props.value.value > 0}
          onChange={(val) => onChange(val ? 1 : 0)}
        />
      </>
    );
  }

  return (
    <>
      {prefix}
      <IONumber
        {...commonProps}
        precision={0}
        appendix={`${props.price.price}৳`}
        htmlProps={{ style: { width: "5em" } }}
      />
    </>
  );
}
